var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 35,
    viewBox: "0 0 23 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C5C6D",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 0.240089L17.4602 5.79055C17.8348 6.1718 17.8348 6.79494 17.4602 7.17751C17.2788 7.36287 17.0383 7.4641 16.7834 7.4641C16.5271 7.46278 16.2892 7.36287 16.1078 7.17751L12.4357 3.44784V23.3306C12.4357 23.8723 12.0059 24.3114 11.4776 24.3114C10.9492 24.3114 10.5195 23.8723 10.5195 23.3306V3.49517L6.89205 7.17751C6.5293 7.54824 5.89976 7.54692 5.53965 7.17882C5.16376 6.79494 5.16376 6.1718 5.53965 5.79055L11.0018 0.240089C11.3172 -0.0806865 11.6852 -0.0793718 11.998 0.240089ZM23 14.1227V32.5279C23 33.7978 21.9696 34.8285 20.7 34.8285H2.3C1.02909 34.8285 0 33.7978 0 32.5279V14.1227C0 12.8515 1.02909 11.8221 2.3 11.8221H7.21543V13.7941H3.17531C2.51029 13.7941 1.97143 14.3331 1.97143 14.9983V31.6523C1.97143 32.3162 2.51029 32.8565 3.17531 32.8565H19.8247C20.4897 32.8565 21.0286 32.3162 21.0286 31.6523V14.9983C21.0286 14.3331 20.4897 13.7941 19.8247 13.7941H15.7714V11.8221H20.7C21.9696 11.8221 23 12.8515 23 14.1227Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.e2e30cb65ab918123ac049ea2113151d.svg";
export { ForwardRef as ReactComponent };